import { Box, Stack, Typography } from '@mui/material';
import type { BaseTheme } from 'design-system';
import BtnIcon from 'components/BtnIcon';
import type { ButtonIcon } from 'generated/graphql';

export type InfoBarColor = 'info' | 'warning';

const colorTokens = (theme: BaseTheme, color: InfoBarColor) =>
  color === 'warning'
    ? {
        background: theme.palette.warning.highlight,
        border: theme.palette.warning.main,
        icon: theme.palette.warning.main,
      }
    : {
        background: theme.palette.tertiary.light,
        border: theme.palette.tertiary.main,
        icon: theme.palette.text.secondary,
      };

const InfoBar = (params: { icon?: ButtonIcon; label?: string; value?: string; color?: InfoBarColor }) => {
  const { icon, label, value, color = 'info' } = params;
  return (
    <Stack
      direction="row"
      sx={(theme) => {
        const tokens = colorTokens(theme, color);
        return {
          alignItems: 'center',
          gap: theme.spacing(1.5),
          padding: theme.spacing(1.5, 2),
          borderRadius: theme.spacing(1),
          border: `1px solid ${tokens.border}`,
          background: tokens.background,
        };
      }}
    >
      {icon && (
        <Box sx={(theme) => ({ display: 'flex', flexShrink: 0, color: colorTokens(theme, color).icon })}>
          <BtnIcon icon={icon} size={20} />
        </Box>
      )}
      <Typography variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {label}
        {label && value && <br />}
        {value && (
          <Box
            component="span"
            sx={(theme) => ({ fontWeight: theme.typography.fontWeightMedium, color: theme.palette.text.primary })}
          >
            {value}
          </Box>
        )}
      </Typography>
    </Stack>
  );
};

export default InfoBar;
